const EmptyState = ({ icon = '📭', title = 'কোনো তথ্য নেই', description, action }) => (
  <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
    <div className="text-5xl mb-3 opacity-70">{icon}</div>
    <h3 className="text-base font-semibold text-ink-900 dark:text-white mb-1">{title}</h3>
    {description && (
      <p className="text-sm text-ink-500 dark:text-ink-400 max-w-sm mb-4">{description}</p>
    )}
    {action}
  </div>
);

export default EmptyState;
